
import { CAlertModal, getLocalization } from '@tokyojob/frontend-components'
import { CandidateLoginMetaFactory, IHead } from '@tokyojob/frontend-core'
import Vue from 'vue'
import CandidateLoginForm from '~/modules/auth/components/candidate/candidate-login-form.component.vue'
import LoginMixin from '~/modules/auth/mixins/login.mixin'
import ValidateUnconfirmedAccountUsecase from '~/modules/auth/usecases/validate-unconfirmed-account.usecase'
import CAlertModalBodyGeneric from '~/modules/vacancy/components/error-alert-modal-body/c-alert-modal-body-generic.vue'

export default Vue.extend({
  layout: 'auth',
  components: { CandidateLoginForm, CAlertModal, CAlertModalBodyGeneric },
  mixins: [LoginMixin],
  async asyncData({ query, App }): Promise<void> {
    if (query.uuid) {
      // we try to confirm the account, but we do not do anything with the result
      const usecase = new ValidateUnconfirmedAccountUsecase(App)
      await usecase.execute(query.uuid as string)
    }
  },
  head(): IHead {
    const locale = this.App.localizationSelector.languageLocale
    const localization = getLocalization(this.App)
    const meta = CandidateLoginMetaFactory.metaTags(localization, locale)
    const title = meta[0].content
    return { title, meta }
  }
})
